import React, { Fragment, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import { ErrorBoundary } from "../_helper/ErrorBoundary";
import Loader from "../Layout/Loader";
import { routes } from "./Routes";
import AppLayout from "../Layout/Layout";
import NotFound from "../Components/Errors/NotFound";

const LayoutRoutes = () => {
  return (
    <Routes>
      {routes.map(({ path, Component }, i) => (
        <Fragment key={i}>
          <Route element={<AppLayout />}>
            <Route
              path={path}
              element={
                <ErrorBoundary componentName={path}>
                  <Suspense fallback={<Loader />}>
                    <Component />
                  </Suspense>
                </ErrorBoundary>
              }
            />
          </Route>
        </Fragment>
      ))}

      <Route element={<AppLayout />}>
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
};

export default LayoutRoutes;
